/**
 * @fileoverview Mock backend for a tenant's Activity history.
 * @description Registers GET /sales/tenants/:id/activities and POST /sales/tenants/:id/activities
 * on the feature's shared mock adapter (see sales-mock-adapter.ts), backed by
 * activities-mock-store.ts. The one endpoint pair both "Tenant Activities" (opened from a bank's
 * row) and View Tenant's own activities tab read from, per every spec's "Both entry points display
 * the same records." New, additive API surface — see tenants-mock.service.ts's file header for why
 * no existing page/hook is wired to it yet.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { addActivity, listActivitiesForTenant } from './activities-mock-store'
import { salesMockAdapter } from './sales-mock-adapter'
import { findTenantById } from './tenants-mock-store'

import type { AddActivityInput } from './activities-mock-store'

if (salesMockAdapter) {
  salesMockAdapter.onGet(/^\/sales\/tenants\/[^/]+\/activities$/).reply((config) => {
    const tenantId = config.url?.split('/').at(-2)
    if (!tenantId || !findTenantById(tenantId)) {
      return [404, { appCode: '1404', message: 'Tenant not found.' }]
    }
    return [200, listActivitiesForTenant(tenantId)]
  })

  salesMockAdapter.onPost(/^\/sales\/tenants\/[^/]+\/activities$/).reply((config) => {
    const tenantId = config.url?.split('/').at(-2)
    const tenant = tenantId ? findTenantById(tenantId) : undefined
    if (!tenantId || !tenant) {
      return [404, { appCode: '1404', message: 'Tenant not found.' }]
    }
    if (tenant.status !== 'Prospect') {
      // 422, not 403 — see targets-mock.service.ts's stage handler for why.
      return [
        422,
        {
          appCode: '1422',
          message: 'Sales users have read-only access once a bank becomes an Active Client.',
        },
      ]
    }

    const input = JSON.parse(config.data as string) as AddActivityInput
    return [201, addActivity(tenantId, input)]
  })
}
